(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/dialog-contextual/assets/javascripts/contextual-area.js') >= 0) return;  svs.modules.push('/components/components/dialog-contextual/assets/javascripts/contextual-area.js'); "use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }


(function (svs, TweenLite) {
  'use strict';

  svs = svs || {};
  svs.components = svs.components || {};
  svs.components.dialog = svs.components.dialog || {};

  var DialogContextualArea = function (_svs$components$dialo) {
    _inherits(DialogContextualArea, _svs$components$dialo);

    var _super = _createSuper(DialogContextualArea);

    function DialogContextualArea(options) {
      var _this;

      _classCallCheck(this, DialogContextualArea);

      _this = _super.call(this);
      _this.log = new svs.core.log.Logger('DialogContextualArea');
      _this.name = svs.components.dialog.area.CONTEXTUAL;
      _this.items = [];
      _this.el = options.el;
      _this.options = options;
      return _this;
    }

    _createClass(DialogContextualArea, [{
      key: "init",
      value: function init() {
        if (!this.el) {
          this.el = document.createElement('div');
          this.el.className += 'js-dialog-items dialog-items dialog-contextual-items js-dialog-contextual-items';
          document.body.appendChild(this.el);
        }
      }
    }, {
      key: "add",
      value: function add(dialog) {
        this.init();
        this.el.classList.remove('dialog-contextual-items-closed');
        this.el.setAttribute('style', "z-index:".concat(dialog.zIndex, ";"));
        dialog.el.className += ' dialog-popup-item dialog-contextual-item';
        dialog.allowDimmerClick = true;
        this.append(dialog);
        dialog.reveal();
      }
    }, {
      key: "close",
      value: function close() {
        this.log.info('No more dialogs here, close container');
        this.el.classList.add('dialog-contextual-items-closed');
        document.body.removeChild(this.el);
        this.el = null;
      }
    }, {
      key: "append",
      value: function append(dialog) {
        var _this2 = this;

        this.log.info('Append dialog to be opened');
        dialog._queue = this;
        dialog.on('closed', this, function () {
          _this2.log.info('A dialog was closed, now handle it.');

          _this2.unload(dialog);
        });
        this.items.push(dialog);
        this.el.appendChild(dialog.el);
      }
    }, {
      key: "unload",
      value: function unload(dialog) {
        var _this3 = this;

        this.items.forEach(function (item, i) {
          if (item._id === dialog._id) {
            _this3.items.splice(i, 1);

            TweenLite.to(item.el, 0.2, {
              opacity: 0,
              onComplete: function onComplete() {
                _this3.el.removeChild(item.el);

                if (!_this3.items.length) {
                  _this3.close();
                }
              }
            });
            item._rendered = false;
          }
        });
      }
    }, {
      key: "closeFromOutside",
      value: function closeFromOutside() {
        if (this.items[0]) {
          this.items[0].close();
        }
      }
    }, {
      key: "status",
      value: function status() {
        this.log.info("".concat(this.name, " queue, ").concat(this.items.length, " still remain"));
      }
    }]);

    return DialogContextualArea;
  }(svs.components.dialog.PubSub); 


  svs.components.dialog.DialogContextualArea = DialogContextualArea;
  svs.components.dialog.area = svs.components.dialog.area || {};
  svs.components.dialog.area.CONTEXTUAL = 'contextual';
  svs.components.dialog.areas = svs.components.dialog.areas || {};
  svs.components.dialog.areas[svs.components.dialog.area.CONTEXTUAL] = svs.components.dialog.DialogContextualArea;
})(svs, TweenLite);
 })(window);